import { render, staticRenderFns } from "./wrappLeaveComment.vue?vue&type=template&id=0e4fbb3c&scoped=true&"
import script from "./wrappLeaveComment.vue?vue&type=script&lang=js&"
export * from "./wrappLeaveComment.vue?vue&type=script&lang=js&"
import style0 from "./wrappLeaveComment.vue?vue&type=style&index=0&id=0e4fbb3c&lang=scss&scoped=true&"
import style1 from "./wrappLeaveComment.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e4fbb3c",
  null
  
)

export default component.exports